import { useEffect, useState } from 'react';

import { TUseDebounceOptions } from '@/shared/hooks/use-debounce/use-debounce.types';

const DEBOUNCE_TIMEOUT = 500;

export const useDebounce = <T>({
  value,
  delay = DEBOUNCE_TIMEOUT,
  disabled = false,
  afterDebounce,
}: TUseDebounceOptions<T>): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    if (disabled) {
      return;
    }
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      afterDebounce?.(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay, disabled]);

  return debouncedValue;
};
